import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./PhotoGuideModal.module.css";
import { useFocusTrap } from "../hooks/useFocusTrap";
import { useHistoryBackClose } from "../hooks/useHistoryBackClose";

// Guia de como tirar as fotos de progresso, dentro do próprio app. Antes era
// um link com target="_blank" pra imagem em /uploads: no PWA instalado (e no
// app) a imagem abria numa aba do navegador sem jeito de voltar pro app.
// Aqui é uma camada por cima do modal de medidas/fotos: fecha pelo X, Esc,
// toque fora e pelo botão/gesto de voltar do celular (useHistoryBackClose).
// Portal no body pra ficar acima de qualquer modal que o abriu.
export default function PhotoGuideModal({ open, onClose, imageUrl }) {
  const ref = useRef(null);
  const [failed, setFailed] = useState(false);
  useFocusTrap(ref, open, onClose);
  useHistoryBackClose(open, onClose);

  if (!open) return null;

  return createPortal(
    <div className={styles.overlay} onClick={onClose} role="presentation">
      <div
        ref={ref}
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="photo-guide-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h2 id="photo-guide-title" className={styles.title}>
            <FontAwesomeIcon icon={faCamera} /> Como tirar as fotos
          </h2>
          <button type="button" className={styles.close} onClick={onClose} aria-label="Fechar guia">
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <div className={styles.body}>
          {failed ? (
            <p className={styles.error}>Não foi possível carregar o guia agora. Tente de novo em instantes.</p>
          ) : (
            <img
              src={imageUrl}
              alt="Guia ilustrado das posições para as fotos de progresso: frente, costas e as duas laterais"
              className={styles.image}
              onError={() => setFailed(true)}
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
